// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__6zyhl","link":"style_link__rINwN"};